import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "@mui/material";

import { toggleMute } from "stores/audio/AudioStateSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeUp, faVolumeMute } from "@fortawesome/free-solid-svg-icons";

import { RootState } from "stores/Store";

interface SoundControlProps {
  buttonStyle?: React.CSSProperties;
  iconSize?: "1x" | "2x" | "3x" | "4x" | "5x";
}

function SoundControl({ buttonStyle, iconSize = "2x" }: SoundControlProps) {
  const dispatch = useDispatch();
  const isMuted = useSelector((state: RootState) => state.audioReducer.isMuted);

  const handleToggleMute = () => {
    dispatch(toggleMute());
  };

  return (
    <Button
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1000,
        ...buttonStyle,
      }}
      onClick={handleToggleMute}
    >
      <FontAwesomeIcon
        size={iconSize}
        icon={isMuted ? faVolumeMute : faVolumeUp}
        color="white"
      />
    </Button>
  );
}

export default SoundControl;
